/**
 * 基于 sessionId 哈希的确定性采样函数
 * 用于全局采样率控制，决定 SDK 是否初始化
 */

/**
 * 判断当前会话是否应被采样
 * @param sessionId 会话ID
 * @param samplingRate 采样率 (0~100)
 * @returns true=需要采样(SDK应初始化), false=不采样
 */
export function shouldSample(sessionId: string, samplingRate: number): boolean {
  if (samplingRate >= 100) return true
  if (samplingRate <= 0) return false

  // djb2 哈希算法（与 hashString 一致），返回 32 位无符号整数
  let hash = 0
  for (let i = 0; i < sessionId.length; i++) {
    const char = sessionId.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash
  }
  const hashValue = (hash >>> 0) % 100 // 0~99

  return hashValue < samplingRate
}
